module.exports = __webpack_public_path__ + "static/media/misson.f6707dd7.svg";